import React from 'react';

function Navbar() {
  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-800">
            🌟 Model Platform
          </h1>
          <div className="flex gap-4">
            <a href="#models" className="text-gray-600 hover:text-gray-800">Models</a>
            <a href="#about" className="text-gray-600 hover:text-gray-800">About</a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;